import { CollectionContact } from '../model';

export const VISIBLE_CONTACT_LIMIT = 4;

export const isPastDuePlaceholderName = (name: string | null): boolean => /past\s*due|pastdue/i.test(name ?? '');

const buildRecipientSet = (recipientEmails: string[]): Set<string> =>
  new Set(recipientEmails.map((email) => email.toLowerCase()));

const contactIsSelected = (contact: CollectionContact, recipientSet: Set<string>): boolean =>
  contact.emails.some((email) => recipientSet.has(email.toLowerCase()));

const contactSortTier = (contact: CollectionContact, recipientSet: Set<string>): number => {
  if (isPastDuePlaceholderName(contact.name)) return 0;
  if (contact.is_billing_primary === 'A') return 1;
  if (contactIsSelected(contact, recipientSet)) return 2;
  return 3;
};

export const sortContactsForDisplay = (
  contacts: CollectionContact[],
  recipientEmails: string[],
): CollectionContact[] => {
  const recipientSet = buildRecipientSet(recipientEmails);

  return [...contacts].sort((a, b) => {
    const tierDiff = contactSortTier(a, recipientSet) - contactSortTier(b, recipientSet);
    if (tierDiff !== 0) return tierDiff;
    return (a.name ?? '').toLowerCase().localeCompare((b.name ?? '').toLowerCase());
  });
};
